function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import RectShape from '../shapes/Rect';
import CircleShape from '../shapes/Circle';
import LineShape from '../shapes/Line';

var NO_OP = function NO_OP() {
  return undefined;
};

export default function renderShape(_ref) {
  var _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'rect' : _ref$shape,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? NO_OP : _ref$fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? NO_OP : _ref$size,
      width = _ref.width,
      height = _ref.height,
      label = _ref.label,
      item = _ref.item,
      itemIndex = _ref.itemIndex,
      _ref$shapeStyle = _ref.shapeStyle,
      shapeStyle = _ref$shapeStyle === void 0 ? NO_OP : _ref$shapeStyle;
  var props = {
    width: width,
    height: height,
    item: item,
    itemIndex: itemIndex,
    label: label,
    fill: fill(_extends({}, label)),
    size: size(_extends({}, label)),
    style: shapeStyle(_extends({}, label))
  };

  if (typeof shape === 'string') {
    if (shape === 'circle') {
      return /*#__PURE__*/React.createElement(CircleShape, props);
    }

    if (shape === 'line') {
      return /*#__PURE__*/React.createElement(LineShape, props);
    }

    return /*#__PURE__*/React.createElement(RectShape, props);
  }

  if ( /*#__PURE__*/React.isValidElement(shape)) {
    return /*#__PURE__*/React.cloneElement(shape, props);
  }

  if (shape) {
    return /*#__PURE__*/React.createElement(shape, props);
  }

  return null;
}